import * as tslib_1 from "tslib";
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import { getSharingInformation as getSharingInformationService } from 'owa-sharing-data';
export default function getSharingInformation(url) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, error_1, _a, eventName, customData;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getSharingInformationService(url)];
                case 1:
                    response = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    _a = datapoints.GetSharingInformationFailure.datapoint, eventName = _a.name, customData = _a.customData;
                    logUsage(eventName, customData(error_1));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, response];
            }
        });
    });
}
//# sourceMappingURL=getSharingInformation.js.map